<template>
  <div
    v-if="modelData"
    class="ws-main"
    :style="[{'padding-bottom':'220px'}]"
  >
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsTitle v-if="editType==='updateCurrentVersion'">編輯{{_label}}</WsTitle>
    <WsTitle v-else-if="editType==='createVersion'">更新{{label}}版本</WsTitle>
    <WsTitle v-else-if="editType==='updateVersion'">
      編輯歷史版本</WsTitle>
    <WsTitle v-else-if="editType==='duplicateVersion'">複製{{label}}版本</WsTitle>
    <div class="ws-content-section">
      <ValidationObserver
        ref="form"
        class="ws-content-section-observer"
      >
        <v-form
          ref="updateForm"
          @submit.prevent
        >
          <div class="ws-content-section">
            <div class="ws-content-section__primary">
              <WsStateContentBlock
                v-for="(item,itemKey) in primary"
                :key="itemKey"
                :modelData="modelData"
                :type="item.type"
                :label="item.label"
                :title="item.title"
                :remark="item.remark"
                :floors="item.floors"
                :modedFields="fields"
                :fields="item.fields"
                :field="item.field"
                :modelName="item.modelName"
                :modeVersions="item.modeVersions"
                :modeParent="item.modeParent"
                :customButtons="item.customButtons"
                :fieldsRead="item.fieldsRead"
                :updateData="_updateData"
                :customParentData="_customParentData"
                :params="$_getParams(item)"
                :titleKey="item.titleKey"
                :itemVersionCreatable="itemVersionCreatable"
                :itemDeletable="itemDeletable"
                :itemEditable="itemEditable"
                :orderBy="item.orderBy"
                :disableExpandListItemSaveBtn="item.disableExpandListItemSaveBtn"
                @input="$_onInput($event)"
                @fetch="$emit('fetch', $event)"
                @item-changed="$emit('item-changed', $event)"
                :parentModelName="$_getParentModelName(item)"
              ></WsStateContentBlock>
            </div>
            <div class="ws-content-section__secondary">
              <WsStateContentBlock
                v-for="(item,itemKey) in secondary"
                :key="itemKey"
                :modelData="modelData"
                :type="item.type"
                :label="item.label"
                :title="item.title"
                :remark="item.remark"
                :floors="item.floors"
                :modedFields="fields"
                :fields="item.fields"
                :field="item.field"
                :modelName="item.modelName"
                :modeVersions="item.modeVersions"
                :modeParent="item.modeParent"
                :customButtons="item.customButtons"
                :fieldsRead="item.fieldsRead"
                :updateData="updateData"
                :customParentData="_customParentData"
                :params="$_getParams(item)"
                :titleKey="item.titleKey"
                :itemVersionCreatable="itemVersionCreatable"
                :itemDeletable="itemDeletable"
                :itemEditable="itemEditable"
                :orderBy="item.orderBy"
                @input="$_onInput($event)"
                :parentModelName="$_getParentModelName(item)"
              ></WsStateContentBlock>
            </div>
          </div>
        </v-form>
      </ValidationObserver>
    </div>
    <WsMainBottomNav>
      <WsBtn
        v-if="!customBtns.isHideRegularBtns"
        @click="$router.go(-1)"
        color="textSecondary"
        outlined
      >取消</WsBtn>
      <WsBtn
        v-if="!customBtns.isHideRegularBtns"
        @click="$_onSubmit()"
        :loading="submitLoading"
      >送出</WsBtn>
      <WsBtn
        v-for="(btn, btnKey) in customBtns.btns"
        :key="btnKey"
        @click="$_onCustomBtnClicked(btn)"
        :color="btn.color"
        :loading="submitLoading"
        :outlined="btn.outlined"
      >
        {{btn.title}}
      </WsBtn>
    </WsMainBottomNav>
  </div>
</template>

<script>
export default {
  data: () => ({
    isMounted: false,
    modelData: null,
    updateData: {},
    submitLoading: false,
  }),
  methods: {
    $_onInput($event) {
      this.updateData = {
        ...this.updateData,
        ...$event,
      };
      this.$emit("input", this.updateData);
      this.$emit("input-updateData", this.updateData);
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.submitLoading = true;
      try {
        const postData = JSON.parse(JSON.stringify(this.updateData));
        if (this.customUpdateAction) {
          this.customUpdateAction(postData, this.modelData);
        }
        let res = null
        if (this.customSubmitAction) {
          res = await this.customSubmitAction(postData, this.modelData);
        } else if (this.editType !== "updateVersion") {
          res = await this.$axios.patch(
            `/${this.modelName}/${this.id}`,
            postData
          );
        }
        if (this.fields.last_version) {
          if (this.modelData.last_version) {
            try {
              if (this.hasCatchVersion) {
                this.updateData.last_version[`${this.submodelVersionName}s`] =
                  this.modelData.last_version[`${this.submodelName}s`].map(
                    (item) => {
                      return item.last_version.id;
                    }
                  );
              }
              if (this.editType === "createVersion") {
                if (this.hasBindOther) {
                  this.updateData.last_version[this.modelName] =
                    this.modelData.id;
                  await this.$axios.post(
                    `/${this._versionModelName}`,
                    this.updateData.last_version
                  );
                } else {
                  await this.$axios.post(
                    `/${this.modelName}/${this.modelData.id}/${this._versionModelName}`,
                    this.updateData.last_version
                  );
                }
              } else if(this.editType === "duplicateVersion"){
                const {locales} = this.updateData.last_version
                const res = await this.$axios.post(
                  `/${this.modelName}/${this.modelData.id}/copy`,
                  {locales}
                );
                this.submitLoading = false;
                this.$store.dispatch("app/stopNeedSave");
                this.$router.push(`/${this.modelName}/${res.data.data.id}`)
                return
              } else {
                await this.$axios.patch(
                  `/${this._versionModelName}/${this.modelData.last_version.id}`,
                  postData.last_version
                );
              }
              this.submitLoading = false;
              this.$store.dispatch("app/stopNeedSave");
              if (this.$route.query && this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect);
              } else {
                this.$router.push(`/${this.modelName}/${res.data.data.id}`);
              }
            } catch (error) {
              alert("更新發生錯誤");
              this.submitLoading = false;
            }
          } else {
            if (this.editType !== "updateVersion") {
              try {
                await this.$axios.post(
                  `/${this.modelName}/${res.data.data.id}/${this._versionModelName}`,
                  this.updateData.last_version
                );
                this.submitLoading = false;
                this.$store.dispatch("app/stopNeedSave");
                if (this.$route.query && this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect);
                } else {
                  this.$router.push(`/${this.modelName}/${res.data.data.id}`);
                }
              } catch (error) {
                alert("更新發生錯誤");
              }
            } else {
              try {
                await this.$axios.put(
                  `/${this._versionModelName}/${this.$route.params.version_id}`,
                  this.updateData
                );
                this.submitLoading = false;
                this.$store.dispatch("app/stopNeedSave");
                if (this.$route.query && this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect);
                } else {
                  this.$router.push(`/${this.modelName}/${this.$route.params.id}/version`);
                }
              } catch(error) {
                alert(error)
                alert("更新發生錯誤")
                this.submitLoading = false;
              }
            }
            this.submitLoading = false;
          }
        } else if (this.editType === "updateVersion") {
          try {
            await this.$axios.patch(
              `/${this._versionModelName}/${this.modelData.id}`,
              this.updateData
            );
            this.submitLoading = false;
            this.$store.dispatch("app/stopNeedSave");
            if (this.$route.query && this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect);
            } else {
              this.$router.push(`/${this.modelName}/${this.$route.params.id}`);
            }
          } catch (error) {
            alert(error);
            this.submitLoading = false;
          }
        } else {
          this.$store.dispatch("app/stopNeedSave");
          if (this.$route.query && this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push(`/${this.modelName}/${res.data.data.id}`);
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data.message === 'email has been token.') {
          alert(this.$locales[error.response.data.message])
        } else {
          alert(error);
        }
        this.submitLoading = false;
      }
    },
    $_getParentModelName(primaryItem) {
      if (primaryItem.modeVersions) {
        return `${this.modelName}_version`;
      } else {
        return this.modelName;
      }
    },
    async $_fetchData() {
      this.$store.dispatch("app/startPageLoading");
      this.$store.dispatch("locale/changeLanguageDisable");
      let getUrl = "";
      if (this.editType === "updateVersion") {
        getUrl = `/${this._versionModelName}/${this.$route.params.version_id}`;
      } else {
        getUrl = `/${this.modelName}/${this.id}`;
      }
      try {
        const res = await this.$axios.get(getUrl);
        if (this.multiUrl) {
          const task = []
          this.multiUrl(res.data.data).forEach((url)=>{
            task.push(this.$axios.get(url))
          })
          const multiRes = await Promise.all(task);
          multiRes.forEach((result)=>{
            this.modelData = {...this.modelData, ...result.data.data}
          })
        }
        this.modelData = {...this.modelData, ...res.data.data};
        if (this.staticModelData) {
          this.staticModelData(this.modelData, this.fields);
        }
        this.$emit("input", this.modelData);
        this.$_CMS_updateDataSetFromFields(
          this,
          this.updateData,
          this.fields,
          this.modelData
        );
        setTimeout(() => {
          this.isMounted = true;
        }, 0);
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    $_getParams(item) {
      let _params = {};
      //送版本params
      if (item.modeParentVersions) {
        if (this.hasSequence || this.hasChapters || this.hasCatchVersion) {
          _params[this.modelVersionName] = this.modelData.last_version.id;
          _params[`${this.modelVersionName}s`] = this.modelData.last_version.id;
        } else if (item.isVersionAPI) {
          _params[`${this.modelVersionName}s`] = this.modelData.last_version
          ? this.modelData.last_version.id
          : this.modelData[`${this.modelVersionName}`]
          ? this.modelData[`${this.modelVersionName}`].id
          : null
        } else {
          _params[`${this.modelName}_version`] = this.$_getParentState(item);
        }
      }
      return _params;
    },
    async $_onCustomBtnClicked(btn) {
      if (btn.isValidateForm){
        const isValidate = await this.$refs.form.validate();
        if (!isValidate) return;
      }
      if (btn.emit) this.$emit(btn.emit, {updateData: this.updateData});
    },
  },
  computed: {
    _customParentData() {
      if (this.customParentData && this.updateData) {
        return this.customParentData(this.updateData);
      } else {
        return null;
      }
    },
    _title() {
      if (!this.modelData) {
        return this.label;
      } else if (this.modelData.name) {
        return this.modelData.name;
      } else {
        return this.$_CMS_getValueByFieldKey(this.titleKey, this.modelData);
      }
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _breadcrumbsItems() {
      if (this.customBreads) {
        return this.customBreads;
      } else {
        const _breadcrumbsItems = [];
        _breadcrumbsItems.push({
          text: this.label,
          to: `/${this.modelName}`,
          disabled: false,
        });
        _breadcrumbsItems.push({
          text: this._title,
          to: `/${this.modelName}/${this.id}`,
          disabled: false,
        });
        if (this.editType === "updateCurrentVersion") {
          _breadcrumbsItems.push({
            text: "編輯當前版本題目",
            disabled: true,
          });
        } else if (this.editType === "createVersion") {
          _breadcrumbsItems.push({
            text: "更新題目版本",
            disabled: true,
          });
        } else if (this.editType === "updateVersion") {
          _breadcrumbsItems.push({
            text: `${this._title} 版本列表`,
            to: `/${this.modelName}/${this.id}/version`,
            disabled: false,
          });
          _breadcrumbsItems.push({
            text: `編輯歷史版本`,
            disabled: true,
          });
        }
        return _breadcrumbsItems;
      }
    },
    _backRouteText() {
      if (this.backRouteText) {
        return "返回";
      } else {
        return `${this.label}列表`;
      }
    },
    _backRoute() {
      if (this.backRoute) {
        return this.backRoute;
      } else {
        return `/${this.modelName}`;
      }
    },
    _versionModelName() {
      if (this.modelVersionName) {
        return this.modelVersionName;
      }
      return `${this.modelName}_version`;
    },
    _updateData() {
      if (this.editType === "duplicateVersion" && this.updateData.last_version) {
        let _updateData = JSON.parse(JSON.stringify(this.updateData))
        for (let key in this.updateData.last_version.locales) {
          _updateData.last_version.locales[key].name = _updateData.last_version.locales[key].name + " - " + this.$locales[this.editType]
        }
        return _updateData
      } else {
        return this.updateData
      }
    },
    _label() {
      return this.pageTitle
      ? this.pageTitle
      : this.label
    }
  },
  props: {
    staticModelData: {
      type: Function,
    },
    titleKey: {
      type: String,
      default: "text",
    },
    backRouteText: {
      type: String,
      default: "返回",
    },
    backRoute: {
      type: String,
      default: null,
    },
    primary: {
      type: Array,
      default() {
        return [];
      },
    },
    secondary: {
      type: Array,
      default() {
        return [];
      },
    },
    modelName: {
      type: String,
      default: "",
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    submodelName: {
      type: String,
      default: "",
    },
    submodelVersionName: {
      type: String,
      default: "",
    },
    label: String,
    fields: Object,
    id: {
      type: [String, Number],
      default: null,
    },
    editType: {
      type: String,
      default: "updateCurrentVersion",
    },
    submodelFields: {
      type: Object,
      default() {
        return {};
      },
    },
    haveQuestions: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Function,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    hasBindOther: {
      type: Boolean,
      default: false,
    },
    customBreads: {
      type: Array,
    },
    customUpdateAction: {
      type: Function,
    },
    multiUrl: {
      type: Function,
    },
    itemVersionCreatable: {
      type: Boolean,
      default: false,
    },
    itemDeletable: {
      type: Boolean,
      default: true,
    },
    itemEditable: {
      type: Boolean,
      default: true,
    },
    pageTitle: {
      type: String,
    },
    customBtns: {
      type: Object,
      default:function(){
        return {
          isHideRegularBtns: false
        }
      }
    },
    customSubmitAction: {
      type: Function,
    },
  },
  mounted() {
    this.$_fetchData();
  },
  watch: {
    updateData: {
      handler() {
        if (this.isMounted) {
          this.$store.dispatch("app/startNeedSave");
        }
      },
      deep: true,
    },
  },
};
</script>